// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3hTl0","colBig":"styles_colBig__8jnAr","colSmall":"styles_colSmall__3NBA0"};